import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { THEME_KEY } from "../lib/constants";
import { ToastProvider } from "../components/ui/toast";
import { useAuthStore } from "../features/auth/authStore";

export function AppProviders({ children }: { children: ReactNode }) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1
          }
        }
      }),
    []
  );
  const [themeReady, setThemeReady] = useState(false);
  const initializeAuth = useAuthStore((state) => state.initialize);

  useEffect(() => {
    const stored = localStorage.getItem(THEME_KEY);
    document.documentElement.classList.toggle("dark", stored === "dark");
    setThemeReady(true);
    void initializeAuth();
  }, [initializeAuth]);

  if (!themeReady) return null;

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>{children}</ToastProvider>
    </QueryClientProvider>
  );
}
